/* eslint-disable class-methods-use-this */
import _axios, { put, _delete } from '@/utils/axios'
class Config {
    /**
     * 获取列表
     */

    // 类中的方法可以代表一个用户行为
    async getConfig() {
        console.log('进入getall')
        const res = await _axios.get(`config`)
        return res
    }



    async update(data) {
        console.log('update data', data)
        data.config = '{"select_number":' + data.select_number + ',"textarea":' + '"' + String(data.textarea) + '"' + '}'
        data.username = 'deckers'
        if (!data.select_number) {
            return
        }
        data.selectNumber = data.select_number
        return _axios({
            method: 'put',
            url: 'config',
            data,
        })
    }



    async create(data) {
        return _axios({
            method: 'post',
            url: 'user',
            data,
        })
    }
    // 删除
    async _delete(id) {
        return _delete(`user?id=${id}`)
    }





}

export default new Config()
